export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-05.42296cfc.jpg";